import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useScheduleCredentialsQuery } from 'src/api/queries/schedulesQueries';
import styles from './AuthorizeBanner.module.scss';

interface AuthorizeBannerProps {
  /** Read-only mode — the feature isn't enabled yet, so the CTA is shown
   *  but disabled. */
  disabled?: boolean;
}

export const AuthorizeBanner: React.FC<AuthorizeBannerProps> = ({ disabled }) => {
  const history = useHistory();
  const location = useLocation();
  const { data, isLoading } = useScheduleCredentialsQuery();

  if (isLoading || data?.has_credential) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className={styles.icon}>
          <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="1.5" />
          <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
        <div>
          <strong>Authorization required</strong>
          <p>Agents run as you, even after you log out. Authorize the scheduler to grant it access to your account.</p>
        </div>
      </div>
      <button
        className={styles.cta}
        disabled={disabled}
        onClick={() => history.push(`/ai/schedules/authorize?return_to=${encodeURIComponent(location.pathname)}`)}
      >
        Authorize scheduler
      </button>
    </div>
  );
};
